export const HELPS = [
{
        id: 0,
        name: "Objective",
        image: "/assets/images/objective.jpeg",
        featured: true,
        description: "Time Tax seeks to launch a new line of services - small business bookkeeping - which will be offered to the same ongoing clients as Sorcerer's"
    }
]